import OurTeam from "./components/OurTeam"
export default OurTeam
